// extracted by mini-css-extract-plugin
export var externalLink = "_du-0";
export var internalLinkLabel = "_du-1";